import { getIn } from "formik";
import {
  FormControl,
  InputLabel,
  FormGroup,
  FormControlLabel,
  Checkbox,
  Typography,
} from "@mui/material";
import CustomDivider from "../../utils/CustomDivider";

export const CheckboxGroupFormField = ({
  field,
  form,
  label,
  options,
  isRequired = false,
  isId = false
}) => {
  const errorText =
    getIn(form.touched, field.name) && getIn(form.errors, field.name);

  // Toggle checkbox
  const handleChange = (value) => {
    const currentValues = field.value || [];

    if (currentValues.includes(value)) {
      // Remove
      const updated = currentValues.filter((v) => v !== value);
      form.setFieldValue(field.name, updated);
    } else {
      // Add
      form.setFieldValue(field.name, [...currentValues, value]);
    }
  };

  return (
    <FormControl component="fieldset" error={!!errorText} fullWidth>
      {label && (
        <InputLabel sx={{ ml: -1.6 }} shrink htmlFor={field.name}>
          <Typography variant="h6" sx={{ textTransform: "capitalize" }}>
            {label}
            {isRequired && (
              <Typography variant="h5" color="error" component="span">
                {" *"}
              </Typography>
            )}
          </Typography>
        </InputLabel>
      )}

      <CustomDivider size={"1rem"} />

      <FormGroup row>
        {options.map((option) => {
          const checkboxValue = isId ? option.id : option.value;

          return (
            <FormControlLabel
              key={checkboxValue}
              control={
                <Checkbox
                  checked={(field.value || []).includes(checkboxValue)}
                  onChange={() => handleChange(checkboxValue)}
                  sx={{
                    color: "#4169E1",
                    "&.Mui-checked": { color: "#4169E1" },
                  }}
                />
              }
              label={<Typography variant="h6">{option.label}</Typography>}
            />
          );
        })}
      </FormGroup>

      {errorText && (
        <Typography variant="h6" fontSize={"10px"} color="red">
          {errorText}
        </Typography>
      )}
    </FormControl>
  );
};
